// @flow
// Decoders
import { createDecoder } from 'fc-decoders'
import decoder from './decoder'

// Exports
export default createDecoder(decoder)
